goog.provide('el8.tourguide.supportGuideSplash');

goog.require('el8.tourguide.Splash');
goog.require('el8.template.tourguide.supportGuideSplash');

el8.tourguide.supportGuideSplash = (function() {

    var that = new el8.tourguide.Splash({
        opacity: 0.7,
        zIndex: 5,
        backgroundColor: 'black',
        contentFn: el8.template.tourguide.supportGuideSplash.content,
        overlayContentFn: el8.template.tourguide.supportGuideSplash.pointers,
        clickTriggerMap: {
            '.end-trigger': function() { that.hide(); }
        }
    });

    var super_positionDialog = that._positionDialog;

    that._positionDialog = function () {
        super_positionDialog.call(that);

        // position an arrow pointing to the "i need help" menu item
        var $help = $("#helpnav");
        var $helpPointer = $(".help-pointer", that.getOverlay());
        if ($help.length && $helpPointer.length) {
            $helpPointer.css({
                top: $help.offset().top + $help.outerHeight(true) + 5,
                left: $help.offset().left - 25,
                position: "absolute",
            });
        }
    };

    return that;

})();


